(function(window,$) {

	$(window).load(function() {
		removeLoader();
	});

	function removeLoader() {
		$('body').addClass('app_loaded');
		$('.app_loader').fadeOut('slow');
	}

})(window,jQuery);
